import { ColDef, KeyCreatorParams, ValueFormatterParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { IFundDataModel } from '../../../data-models/fund.data-model';
import { FundProfileLinkRenderer } from '../../PortfolioOverview/components/OverviewTable/columns/TypeBasedConfigs/TypeCellRenderers/FundProfileLinkRenderer';
import { fundLabelForTransaction } from '../fundLabel';
import { IExtendedTransactionDataModel } from './useAllTransactionsData';

type FundCellParams = CustomCellRendererProps<IExtendedTransactionDataModel, number | null>;

// Family-only rows carry no fundId, so the schema's fund-id renderer would show nothing for them.
export function AllTransactionsFundRenderer(params: FundCellParams) {
  if (params.data?.fundId != null) {
    return <FundProfileLinkRenderer {...(params as CustomCellRendererProps)} />;
  }
  return <>{params.valueFormatted ?? ''}</>;
}

// The cell value stays the raw fundId (so the fund-id comparator and export keep working); only
// the label layer knows a familyId-only row should read as its family shadow fund.
export function allTransactionsFundColDef(
  fundsById: Map<number, IFundDataModel>
): ColDef<IExtendedTransactionDataModel> {
  const label = (
    params:
      ValueFormatterParams<IExtendedTransactionDataModel> | KeyCreatorParams<IExtendedTransactionDataModel>
  ) => fundLabelForTransaction(params.data ?? undefined, fundsById);

  return {
    filter: false,
    valueFormatter: label,
    keyCreator: label,
    cellRenderer: AllTransactionsFundRenderer,
  };
}
